const industryMap = {
  'patch-cord': [5, 8, 22],
  'breakout': [5, 8, 23],
  'trunk': [5,8, 24]
}

export function getIndustryIds ({ route }) {
  return industryMap[route]
}